import { action, makeAutoObservable } from 'mobx';
import { PropsType } from 'src/components/Filters/FilterTabs';

export class FilterTabsState {
    public constructor(private readonly props: PropsType) {
        makeAutoObservable(this);
    }

    @action public selectActive = (id: string): void => {
        this.props.onChange(id);
        if (this.props.onChange !== undefined) {
            this.props.onChange(id);
        }
    };
}
